import type { CSSProperties } from 'react';
import {
  textStyles,
  type TextStyleTokens,
} from '../../../../utils/richText/textStyles';

interface StateToStyleArgs {
  state?: Record<string, unknown>;
  tokens: TextStyleTokens;
}

export const stateToStyle = ({
  state,
  tokens,
}: StateToStyleArgs): CSSProperties =>
  Object.entries(textStyles).reduce<CSSProperties>((style, [key, group]) => {
    const value = state?.[key];
    const definition = typeof value === 'string' ? group[value] : undefined;
    return definition ? { ...style, ...definition.style(tokens) } : style;
  }, {});
